export const date_filter_en = {
  all: "All",
  oneWeek: "Last 1 Week",
  oneMonth: "Last 1 Month",
  oneYear: "Last 1 Year",
};
